import styles from './style.module.scss';
import Modal from '../../../../../components/Modal';
import { useDispatch, useSelector } from '../../../../../store/store';
import { RemoveMemberIcon, RemoveMemberSquareIcon } from '../../../../../assets/icons';
import Button from '../../../../../components/Button';
import { getProfileDataThunk, leaveOrganizationThunk } from '../../../../../store/workspace/thunks';
import { useState } from 'react';
import { setConfirmRemoveMemberModal } from '../../../../../store/workspace/slice';
import { selectUserId } from '../../../../../store/auth/selectors';
import { selectSelectedMemberDetail } from '../../../../../store/workspace/selectors';

export default function ConfirmRemoveMember() {
    const dispatch = useDispatch();
    const userId = useSelector(selectUserId);
    const member = useSelector(selectSelectedMemberDetail);
    const [isLoading, setIsLoading] = useState(false);

    const next = () => {
        if (!userId || !member) return;

        setIsLoading(true);

        dispatch(leaveOrganizationThunk({
            action: 'remove',
            email: member.email,
        }))
            .unwrap()
            .then(() => {
                dispatch(setConfirmRemoveMemberModal(false));
                dispatch(getProfileDataThunk());
            })
            .catch(() => {
                setIsLoading(false);

            })
    };

    return (
        <Modal
            size='sm'
            title='Remove member'
            icon={<RemoveMemberSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setConfirmRemoveMemberModal(false))}
        >
            <RemoveMemberIcon />
            <span className={styles.text}>
                Are you sure you want to remove as member?
            </span>
            <div className={styles.actions}>
                <Button
                    text='Cancel'
                    type='Outline-Dark'
                    disabled={isLoading}
                    className={styles.actions_btn}
                    onClick={() => dispatch(setConfirmRemoveMemberModal(false))}
                />
                <Button
                    type='Error'
                    text='Remove'
                    loading={isLoading}
                    onClick={next}
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    )
}
